import React, { useState, useEffect, useCallback } from "react";
import MainLayout from "../Themes/MainLayout";
import { getConfirmDeleteDialog } from "../Components/confirmDeleteDialog";
import axios from "axios";
import Table_theme from "../Themes/TableTheme";
import {
  Alert,
  CssBaseline,
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Snackbar,
  Popover,
  MenuItem,
  InputAdornment,
  Switch,
  Pagination,
  Typography,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FlagIcon from "@mui/icons-material/Flag";
import { Add, FilterList, Search } from "@mui/icons-material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { ReactComponent as DeleteIcon } from "../Icons/Delete.svg";
import { ReactComponent as SettingsIcon } from "../Icons/Settings.svg";
import FormThemes from "../Themes/FormThemes";
import moment from "moment";
import { useCurrentUser } from "../utils/useCurrentUser";
import { formatDateLocal_TF } from "../utils/dateUtils";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiBaseUrl = `${BASE_URL}/api/leave-request`;

const leaveFields = [
  "employee_name",
  "leave_type",
  "leave_description",
  "approval_level_required",
  "approver_id",
  "duration_type",
  "start_date",
  "end_date",
  "total_days",
  "start_time",
  "end_time",
  "total_hours",
  "status",
  "approver_remarks",
  "submitted_at",
  "last_updated",
  "emergency_contact",
 
];

const popupFields = [
  "employee_id",
  "leave_type",
  "leave_description",
  "approval_level_required",
  "duration_type",
  "start_date",
  "end_date",
  "total_days",
  "start_time",
  "end_time",
  "total_hours",
  "emergency_contact",
];
const filterFieldMap = {
  employee_name: "employee_id",
  leave_type: "leave_type",
  status: "status",
  approver_id: "approver_name",
  total_days: "total_days",
  total_hours: "total_hours",
  start_date: "start_date",
  end_date: "end_date",
  start_time: "start_time",
  end_time: "end_time",
  approval_level_required: "approval_level_required",
  duration_type: "duration_type",
};
const fieldLabels = {};
leaveFields.forEach((field) => {
  fieldLabels[field] = field
    .replace(/_/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());
});
fieldLabels.bo_id = "Organization Id";
fieldLabels.employee_id = "Employee Name";
fieldLabels.employee_name = "Employee Name";
fieldLabels.leave_type = "Leave Type";
fieldLabels.approver_id = "Approver Name";

const LeaveRequest = ({ employeeId }) => {
  const { empId, boId, roles } = useCurrentUser();
  const [requests, setRequests] = useState([]);
  const [filters, setFilters] = useState({});
  const [errors, setErrors] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusFilter, setStatusFilter] = useState("ACTIVE");
  const [projectResources, setProjectResources] = useState([]);
  const [approvalHistory, setApprovalHistory] = useState({});
  const [resourcesLoading, setResourcesLoading] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState(
    leaveFields.reduce((acc, f) => ({ ...acc, [f]: true }), {})
  );
  const [anchorEls, setAnchorEls] = useState({});
  const [columnAnchorEl, setColumnAnchorEl] = useState(null);
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [approvalLevel, setApprovalLevel] = useState(null);

  const [newRequest, setNewRequest] = useState({
    duration_type: "Full/Multiple Days",
    bo_id: boId,
    employee_id: empId || "",
    leave_type: "",
    leave_description: "",
    approval_level_required: null,
    start_date: null,
    end_date: null,
    total_days: null,
    start_time: null,
    end_time: null,
    total_hours: null,
    is_half_day: false,
    status: "Pending",
    emergency_contact: null,
    is_draft: false,
    alternative_resource: null,
  });
  const [editRequest, setEditRequest] = useState({});
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [search, setSearch] = useState("");
  const [boOptions, setBoOptions] = useState([]);
  const [boToEmployeesMap, setBoToEmployeesMap] = useState({});
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [leaveTypeLoading, setLeaveTypeLoading] = useState(false);

  const rowsPerPage = 10;

  const calculateTotalDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;

    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = end - start;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return Math.round(diffDays + 1);
    //return diffDays + 1;
  };
  const getAlternativeResourceName = (empId) => {
    if (!empId) return "";
    const emp = projectResources.find((res) => res.employee_id === empId);
    return emp ? `${emp.first_name} ${emp.last_name}` : empId;
  };
  const getEmployeeName = (row) => {
    const employees = boToEmployeesMap[row.bo_id] || [];
    const emp = employees.find((e) => e.employee_id === row.employee_id);
    return emp ? `${emp.first_name} ${emp.last_name}` : row.employee_id;
  };
  const calculateTotalHours = (startTime, endTime) => {
    if (!startTime || !endTime) return null;
    // --- Parse "HH:MM" + optional "AM/PM"
    const parseTime = (timeStr) => {
      const parts = timeStr.trim().split(" ");
      const [timePart, modifier] = parts;
      let [hours, minutes] = timePart.split(":").map(Number);
      // Convert 12-hour times to 24-hour
      if (modifier) {
        const mod = modifier.toUpperCase();
        if (mod === "PM" && hours < 12) hours += 12;
        if (mod === "AM" && hours === 12) hours = 0;
      }
      return { hours, minutes };
    };
    const { hours: startHours, minutes: startMinutes } = parseTime(startTime);
    const { hours: endHours, minutes: endMinutes } = parseTime(endTime);

    // --- Create Date objects on the same day
    const start = new Date(0, 0, 0, startHours, startMinutes);
    const end = new Date(0, 0, 0, endHours, endMinutes);

    // --- Handle overnight case (e.g., 10 PM → 6 AM)
    if (end <= start) end.setDate(end.getDate() + 1);

    const diffMs = end - start;
    const diffHours = diffMs / (1000 * 60 * 60);

    return Number(diffHours.toFixed(2));
  };

  const confirmDelete = (request) => {
    if (!request || !request.request_id) {
      console.error("Invalid request object for delete");
      return;
    }
    setSelectedRequest(request);
    setDeleteDialogOpen(true);
  };
  const formatDays = (days) => {
    if (days === null || days === undefined) return "";
    const totalDays = Math.round(days); // round to nearest integer
    return totalDays === 1 ? "1" : `${totalDays} `;
  };
  const formatHours = (hours) => {
    if (!hours && hours !== 0) return "";

    const wholeHours = Math.floor(hours);
    const minutes = Math.round((hours - wholeHours) * 60);

    if (minutes > 0) {
      return `${wholeHours} hour${
        wholeHours !== 1 ? "s" : ""
      } ${minutes} minute${minutes !== 1 ? "s" : ""}`;
    } else {
      return `${wholeHours} hour${wholeHours !== 1 ? "s" : ""}`;
    }
  };

  const validateRequest = (request, isEdit = false) => {
    const errors = {};
    const requiredFields = [
      "bo_id",
      "employee_id",
      "leave_type",
      "approval_level_required",
      "duration_type",
      "start_date",
    ];

    // Approval level validation
    if (
      request.approval_level_required &&
      (request.approval_level_required < 1 ||
        request.approval_level_required > 3)
    ) {
      errors.approval_level_required = "Approval level must be 1, 2, or 3 only";
    }

    if (request.duration_type === "Full/Multiple Days" && request.end_date) {
      requiredFields.push("total_days");
    } else if (request.duration_type === "Specific Hours") {
      requiredFields.push("start_time", "end_time", "total_hours");
    }

    // Required field check
    requiredFields.forEach((field) => {
      if (!request[field] && request[field] !== 0 && request[field] !== false) {
        errors[field] = `${fieldLabels[field] || field} is required`;
      }
    });

    // Optional field validation
    if (request.emergency_contact) {
      const mobileRegex = /^\+?[0-9]{10,15}$/; // supports optional country code
      if (!mobileRegex.test(request.emergency_contact.trim())) {
        errors.emergency_contact = "Please enter a valid mobile number";
      }
    }

    // --- DATE VALIDATION ---
    if (request.start_date) {
      const today = moment().startOf("day");
      const start = moment(request.start_date);

      // Only check for past date when adding (not editing)
      if (!isEdit && start.isBefore(today)) {
        errors.start_date = "Start date cannot be in the past";
      }
    }

    if (request.start_date && request.end_date) {
      const start = moment(request.start_date);
      const end = moment(request.end_date);
      if (end.isBefore(start)) {
        errors.end_date = "End date must be on or after start date";
      }
    }
   // --- TIME VALIDATION ---
    if (request.duration_type === "Specific Hours") {
      if (request.start_time && request.end_time) {
        const [sh, sm] = request.start_time.split(":").map(Number);
        const [eh, em] = request.end_time.split(":").map(Number);
        let start = new Date(0, 0, 0, sh, sm);
        let end = new Date(0, 0, 0, eh, em);

        if (end <= start) {
          end.setDate(end.getDate() + 1);
        }

        const diff = (end - start) / (1000 * 60 * 60);
        if (diff <= 0) {
          errors.total_hours = "Total hours must be greater than 0";
        }
        if (diff > 24) {
          errors.total_hours = "Total hours cannot exceed 24 hours";
        }
      }
    }

    return errors;
  };

  const handleFilterIconClick = (field, event) => {
    setAnchorEls((prev) => ({ ...prev, [field]: event.currentTarget }));
  };

  const handleFilterClose = (field) => {
    setAnchorEls((prev) => ({ ...prev, [field]: null }));
  };
  const fetchProjectResourcesForEmployee = useCallback(
    async (targetEmployeeId) => {
      try {
        if (!targetEmployeeId) {
          setProjectResources([]);
          return;
        }
        setResourcesLoading(true);
        const res = await axios.get(
          `${apiBaseUrl}/project-resources/${targetEmployeeId}`,
          { params: { bo_id: boId } }
        );
        setProjectResources(res.data || []);
      } catch (err) {
        console.error("Error fetching project resources:", err);
        setProjectResources([]);
      } finally {
        setResourcesLoading(false);
      }
    },
    [boId]
  );
  const fetchData = useCallback(async () => {
    try {
      const mappedFilters = {};
      Object.keys(filters).forEach((key) => {
        if (filters[key]) {
          if (
            ["start_date", "end_date", "submitted_at", "last_updated"].includes(
              key
            )
          ) {
            const parsedDate = moment(filters[key], "MM/DD/YYYY", true);
            if (parsedDate.isValid()) {
              mappedFilters[filterFieldMap[key] || key] =
                parsedDate.format("YYYY-MM-DD");
            } else {
              mappedFilters[filterFieldMap[key] || key] = filters[key];
            }
          } else {
            mappedFilters[filterFieldMap[key] || key] = filters[key];
          }
        }
      });

      const params = {
        page: page + 1,
        limit: rowsPerPage,
        ...mappedFilters,
        ...(search.trim() ? { search: search.trim() } : {}),
        ...(statusFilter ? { status: statusFilter } : { status: "All" }),
        ...(!roles.includes("Admin") && boId ? { bo_id: boId } : {}),
        ...(!roles.includes("Admin") && empId ? { employee_id: empId } : {}),
      };

      const response = await axios.get(`${apiBaseUrl}/paginated`, { params });
      const enrichedRequests = await Promise.all(
        response.data.data.map(async (row) => {
          const history = await fetchApprovalHistory(row.request_id);
          return { ...row, approvalHistory: history };
        })
      );

      setRequests(enrichedRequests);
      setTotalCount(response.data.total);
    } catch (err) {
      console.error("Error fetching paginated leave requests:", err);
      setSnackbarMsg("Failed to fetch requests");
      setShowSnackbar(true);
    }
  }, [page, filters, search, statusFilter]);

  useEffect(() => {
    if (alertMsg) {
      const timer = setTimeout(() => {
        setAlertMsg("");
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [alertMsg]);

  useEffect(() => {
    const fetchStatusFlags = async () => {
      try {
        const res = await fetch(`${BASE_URL}/commonVariables/statusFlag`);
        const data = await res.json();
        setStatusOptions(data);
      } catch (err) {
        console.error("Failed to fetch employee status flags:", err);
      }
    };

    fetchStatusFlags();
  }, []);
  useEffect(() => {
    if (!newRequest.employee_id) return;

    axios
      .get(
        `${BASE_URL}/api/leave-request/approval-level/${newRequest.employee_id}`,
        { params: { bo_id: boId } }
      )
      .then((res) => {
        const level = res.data.approval_level_required || "";
        setApprovalLevel(level); // store it globally
        setNewRequest((prev) => ({
          ...prev,
          approval_level_required: level,
        }));
      })
      .catch((err) => {
        console.error("Error fetching approval level:", err);
      });
  }, [newRequest.employee_id, boId]);

  useEffect(() => {
    if (!editRequest.employee_id) return;

    axios
      .get(
        `${BASE_URL}/api/leave-request/approval-level/${editRequest.employee_id}`,
        { params: { bo_id: boId } }
      )
      .then((res) => {
        const level = res.data.approval_level_required || "";
        setEditRequest((prev) => ({
          ...prev,
          approval_level_required: level,
        }));
      })
      .catch((err) => {
        console.error("Error fetching approval level for edit:", err);
      });
  }, [editRequest.employee_id, boId]);
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    if (newRequest.employee_id) {
      fetchProjectResourcesForEmployee(newRequest.employee_id);
    }
  }, [newRequest.employee_id, boId, fetchProjectResourcesForEmployee]);
  useEffect(() => {
    if (editRequest.employee_id) {
      fetchProjectResourcesForEmployee(editRequest.employee_id);
    }
  }, [editRequest.employee_id, boId, fetchProjectResourcesForEmployee]);
  useEffect(() => {
    setPage(0);
  }, [search, filters, statusFilter]);

  useEffect(() => {
    const params = {};
    if (!roles.includes("Admin")) {
      if (boId) params.bo_id = boId;
      if (empId) params.employee_id = empId;
    }

    axios
      .get(`${apiBaseUrl}/bo-dropdown-options`, { params })
      .then((res) => {
        const boSet = new Set();
        const map = {};
        res.data.forEach((row) => {
          if (row.bo_id) {
            boSet.add(row.bo_id);
            if (!map[row.bo_id]) {
              map[row.bo_id] = [];
            }
            map[row.bo_id].push({
              employee_id: row.employee_id,
              first_name: row.first_name,
              last_name: row.last_name,
            });
          }
        });
        setBoOptions([...boSet]);
        setBoToEmployeesMap(map);
      })
      .catch((err) => {
        console.error("Error fetching BO options:", err);
        setSnackbarMsg("Failed to fetch organization options");
        setShowSnackbar(true);
      });

    setLeaveTypeLoading(true);
    axios
      .get(`${apiBaseUrl}/leave-types`)
      .then((res) => {
        const leaveTypes = res.data.client_type || [];
        if (!Array.isArray(leaveTypes) || !leaveTypes.length) {
          setSnackbarMsg(
            "No leave types available. Please contact the administrator."
          );
          setShowSnackbar(true);
        }
        setLeaveTypeOptions(leaveTypes);
      })
      .catch((err) => {
        console.error("Error fetching leave types:", err);
        setSnackbarMsg(
          err.response?.data?.error || "Failed to fetch leave types"
        );
        setShowSnackbar(true);
      })
      .finally(() => {
        setLeaveTypeLoading(false);
      });
  }, []);

  const handleAdd = async () => {
    const errors = validateRequest(newRequest);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      setAlertSeverity("error");
      return;
    }
    console.log("newRequest:-->", newRequest);
    const transformedRequest = {
      ...newRequest,
      created_by: empId,
      start_date: newRequest.start_date
        ? moment(newRequest.start_date).format("YYYY-MM-DD")
        : null,
      end_date: newRequest.end_date
        ? moment(newRequest.end_date).format("YYYY-MM-DD")
        : null,
      total_days: newRequest.total_days || null,
      start_time: newRequest.start_time ? `${newRequest.start_time}:00` : null,
      end_time: newRequest.end_time ? `${newRequest.end_time}:00` : null,
      total_hours: newRequest.total_hours || null,
      status: "Pending",
      emergency_contact: newRequest.emergency_contact || null,
      alternative_resource: newRequest.alternative_resource || null,
      is_draft: newRequest.is_draft || false,
      is_half_day: newRequest.is_half_day || false,
      approval_level_required: newRequest.approval_level_required || null,
    };

    try {
      await axios.post(apiBaseUrl, transformedRequest, {
        params: { bo_id: boId },
      });
      setOpen(false);
      setNewRequest({
        duration_type: "Full/Multiple Days",
        bo_id: !roles.includes("Admin") ? boId || "" : "",
        employee_id: !roles.includes("Admin") ? employeeId || empId || "" : "",
        leave_type: "",
        leave_description: "",
        approval_level_required: null,
        approver_id: "",
        start_date: null,
        end_date: null,
        total_days: null,
        start_time: null,
        end_time: null,
        total_hours: null,
        is_half_day: false,
        status: null,
        emergency_contact: null,
        is_draft: false,
        alternative_resource: null,
      });
      setErrors({});
      setAlertMsg("Request added successfully!");
      setAlertSeverity("success");
      fetchData();
    } catch (err) {
      console.error("Add failed:", err.response?.data || err.message);

      setAlertMsg("Failed to add request!");
      setAlertSeverity("error");
    }
  };

  const handleEdit = async () => {
    const errors = validateRequest(editRequest, true);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);

      setAlertMsg("Please fill all required fields correctly!");
      setAlertSeverity("error");
      return;
    }
    const transformedRequest = {
      bo_id: editRequest.bo_id,
      employee_id: editRequest.employee_id,
      leave_type: editRequest.leave_type,
      leave_description: editRequest.leave_description,
      approval_level_required: editRequest.approval_level_required || null,
      duration_type: editRequest.duration_type,
      start_date: formatDateLocal_TF(editRequest.start_date),
      end_date: formatDateLocal_TF(editRequest.end_date),
      total_days: editRequest.total_days,
      start_time: editRequest.start_time,
      end_time: editRequest.end_time,
      total_hours: editRequest.total_hours,
      status: editRequest.status || "Pending",
      emergency_contact: editRequest.emergency_contact || null,
      alternative_resource: editRequest.alternative_resource,
      is_draft: editRequest.is_draft || false,
      is_half_day: editRequest.is_half_day || false,
      modified_by: empId,
    };

    try {
      await axios.put(
        `${apiBaseUrl}/${editRequest.request_id}`,
        transformedRequest,
        { params: { bo_id: boId } }
      );
      setEditOpen(false);
      setErrors({});

      setAlertMsg("Request updated successfully!");
      setAlertSeverity("success");
      fetchData();
    } catch (err) {
      console.error("Edit failed:", err.response?.data || err.message);

      setAlertMsg("Failed to Update!");
      setAlertSeverity("error");
    }
  };

  const fetchApprovalHistory = async (requestId) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/leave-request/approval-history/${requestId}`,
        { params: { bo_id: boId } }
      );
      return response.data;
    } catch (err) {
      console.error("Error fetching approval history:", err);
      return [];
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${apiBaseUrl}/${id}`, {
        params: { bo_id: boId },
      });
      if (response.status === 200) {
        setAlertMsg("Request Deleted!");
        setAlertSeverity("success");
        await fetchData();
      }
    } catch (err) {
      console.error(
        "Delete failed, it has corresponding approval page:",
        err.response?.data || err.message
      );
      if (err.response && err.response.data && err.response.data.error) {
        setAlertMsg(err.response.data.error); // shows "linked to projects" message
      } else {
        setAlertMsg("Something went wrong");
      }
      setAlertSeverity("error");
    }
  };

  const handleToggleFlag = async (request_id) => {
    try {
      const response = await axios.patch(
        `${apiBaseUrl}/${request_id}/toggle-flag`,
        {},
        { params: { bo_id: boId } }
      );
      if (response.status === 200) {
        setAlertMsg("Toggle flag updated successfully!");
        setAlertSeverity("success");
        await fetchData();
      }
    } catch (err) {
      console.error("Toggle failed:", err.response?.data || err.message);

      setAlertMsg("Failed to flagg toggled!");
      setAlertSeverity("error");
    }
  };

  const renderField = (field, data, setData) => {
    const requiredFields = [
      "leave_description",
      "employee_id",
      "leave_type",
      "approval_level_required",
      "duration_type",
      "start_date",
      "end_date",
      "start_time",
      "end_time",
      "alternative_resource",
    ];

    const isRequired = requiredFields.includes(field);
    const labelText = `${fieldLabels[field] || field}${
      isRequired ? " " : " (Optional)"
    }`;

     // Function to calculate legend width based on actual text length
    const calculateLegendWidth = (text) => {
      // Create a temporary canvas element to measure text width
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      
      // Set font to match Material-UI label font (scaled down to 0.75)
      context.font = '9px "Roboto", "Helvetica", "Arial", sans-serif';
      
      // Measure the actual text width
      const textWidth = context.measureText(text).width;
      
      // Add small padding for exactly one space after label name
      return `${textWidth + 8}px`;
    };

   const commonFieldStyles = {
  width: "250px",
  mb: 1,
  mt: 1,

  "& .MuiInputLabel-root": {
    transform: "translate(14px, -9px) scale(0.75)",
    transformOrigin: "top left",
    backgroundColor: "#f9f9f9",
    padding: "0 2px",
    lineHeight: "1.2",
    whiteSpace: "nowrap",
  },

  /*  NORMAL TextField */
  "& .MuiOutlinedInput-notchedOutline legend": {
    maxWidth: calculateLegendWidth(labelText),
  },

  /*  FIX FOR DATEPICKER */
  "& .MuiOutlinedInput-notchedOutline legend span": {
    paddingRight: 0,
  },

  "& .MuiOutlinedInput-notchedOutline legend span span": {
    maxWidth: calculateLegendWidth(labelText), // ⬅ key fix
    display: "inline-block",
  },

  "& .MuiInputLabel-shrink": {
    transform: "translate(14px, -9px) scale(0.75)",
  },
};
    const isEmployeeDropdown = field === "employee_id";
    const isLeaveTypeDropdown = field === "leave_type";
    const isDurationType = field === "duration_type";
    const isDateField = field === "start_date" || field === "end_date";
    const isEndDate = field === "end_date";
    const isTotalDays = field === "total_days";
    const isTimeField = ["start_time", "end_time"].includes(field);
    const isTotalHours = field === "total_hours";
    const isNumber = [
      "approval_level_required",
      "total_days",
      "total_hours",
    ].includes(field);

    const handleChange = (field, value) => {
      let newData = { ...data, [field]: value };
      if (isTimeField) {
        const totalHours = calculateTotalHours(
          field === "start_time" ? value : data.start_time,
          field === "end_time" ? value : data.end_time
        );
        newData.total_hours = totalHours;
      } else if (field === "duration_type") {
        if (value === "Specific Hours") {
          newData.end_date = null;
          newData.total_days = null;
        } else {
          newData.start_time = null;
          newData.end_time = null;
          newData.total_hours = null;
        }
      } else if (isDateField) {
        if (data.duration_type === "Full/Multiple Days") {
          const totalDays = calculateTotalDays(
            field === "start_date" ? value : data.start_date,
            field === "end_date" ? value : data.end_date
          );
          newData.total_days = totalDays;
        }
      }

      setData(newData);
      setErrors((prev) => ({ ...prev, [field]: "" }));
    };

    if (field === "alternative_resource") {
      return (
        <TextField
          key={field}
          select
          label={`${labelText}`}
          value={data[field] || ""}
          onChange={(e) => handleChange(field, e.target.value)}
          size="small"
          sx={commonFieldStyles}
          disabled={resourcesLoading || !data.employee_id}
          error={!!errors[field]}
          helperText={errors[field]}
          required={isRequired}
          InputLabelProps={{ shrink: true }}
        >
          <MenuItem value="">
            <em>Select alternative resource</em>
          </MenuItem>
          {resourcesLoading ? (
            <MenuItem disabled>Loading...</MenuItem>
          ) : projectResources.filter(
              (res) => res.employee_id !== data.employee_id
            ).length === 0 ? (
            <MenuItem disabled>No teammates available</MenuItem>
          ) : (
            projectResources
              .filter((res) => res.employee_id !== data.employee_id)
              .map((res) => (
                <MenuItem key={res.employee_id} value={res.employee_id}>
                  {res.first_name} {res.last_name}
                </MenuItem>
              ))
          )}
        </TextField>
      );
    }

    if (field === "approval_level_required") {
      return (
        <TextField
          key={field}
          label={labelText}
          value={data[field] || ""}
          size="small"
          required={isRequired}
          sx={commonFieldStyles}
          InputProps={{ readOnly: true }}
          InputLabelProps={{ shrink: true }}
        />
      );
    }

    if (field === "emergency_contact") {
      return (
        <TextField
          key={field}
          label={labelText}
          value={data[field] || ""}
          onChange={(e) => handleChange(field, e.target.value)}
          size="small"
          required={isRequired}
         sx={commonFieldStyles}
          error={!!errors[field]}
          helperText={errors[field]}
          InputLabelProps={{ shrink: true }}
        />
      );
    }

    const showField = () => {
      if (isEndDate || isTotalDays)
        return data.duration_type !== "Specific Hours";
      if (isTimeField || isTotalHours)
        return data.duration_type === "Specific Hours";
      return true;
    };

    if (!showField()) return null;

    if (isEmployeeDropdown) {
      const employees = data.bo_id ? boToEmployeesMap[data.bo_id] || [] : [];
      return (
        <TextField
          key={field}
          label={labelText}
          value={
            employees.find((emp) => emp.employee_id === data[field])
              ? `${
                  employees.find((emp) => emp.employee_id === data[field])
                    .first_name
                } ${
                  employees.find((emp) => emp.employee_id === data[field])
                    .last_name
                }`
              : ""
          }
          onChange={(e) => handleChange(field, e.target.value)}
          size="small"
          required={isRequired}
        sx={commonFieldStyles}
          error={!!errors[field]}
          helperText={errors[field]}
          disabled
        ></TextField>
      );
    }

    if (isLeaveTypeDropdown) {
      return (
        <TextField
          key={field}
          select
          label={labelText}
          value={data[field] || ""}
          onChange={(e) => handleChange(field, e.target.value)}
          size="small"
          required={isRequired}
         sx={commonFieldStyles}
          error={!!errors[field]}
          helperText={errors[field]}
          disabled={leaveTypeLoading}
          InputLabelProps={{ shrink: true }}
        >
          {leaveTypeOptions.map((opt) => (
            <MenuItem
              key={opt.variable_value}
              value={opt.variable_value}
              sx={{ fontSize: "12px" }}
            >
              {opt.variable_value}
            </MenuItem>
          ))}
        </TextField>
      );
    }

    if (isDurationType) {
      return (
        <TextField
          key={field}
          select
          label={labelText}
          value={data[field] || "Full/Multiple Days"}
          onChange={(e) => handleChange(field, e.target.value)}
          size="small"
          required={isRequired}
          sx={commonFieldStyles}
          error={!!errors[field]}
          helperText={errors[field]}
        >
          <MenuItem value="Full/Multiple Days" sx={{ fontSize: "12px" }}>
            Full/Multiple Days
          </MenuItem>
          <MenuItem value="Specific Hours" sx={{ fontSize: "12px" }}>
            Specific Hours
          </MenuItem>
        </TextField>
      );
    }
    if (isDateField) {
      const isStartDate = field === "start_date";
      const isEndDate = field === "end_date";

      // Determine whether this is an edit form (existing record)
      const isEditMode = !!data?.request_id; // or use your own flag like isEdit

      // Calculate min date logic
      let minDate = moment();
      if (isEndDate && data.start_date) {
        // End date should not be before start date
        minDate = moment(data.start_date);
      }

      const shouldDisable = false;
      return (
        <DatePicker
          key={field}
          label={labelText}
          value={data[field] ? moment(data[field]) : null}
          onChange={(newValue) =>
            handleChange(
              field,
              newValue ? moment(newValue).format("YYYY-MM-DD") : null
            )
          }
          disabled={shouldDisable}
          minDate={minDate}
          slotProps={{
            textField: {
              fullWidth: true,
              size: "small",
              required: isRequired,
              error: !!errors[field],
              helperText: shouldDisable
                ? "Select start date first"
                : errors[field],
              InputLabelProps: { shrink: true },
               sx: commonFieldStyles,
            },
            popper: {
              sx: {
                "& .MuiPickersCalendar-root": {
                  width: 220,
                  fontSize: "0.8rem",
                },
                "& .MuiCalendarPicker-root": {
                  width: 220,
                },
                "& .MuiDay-root": {
                  width: 28,
                  height: 26,
                  fontSize: "0.7rem",
                },
              },
            },
          }}
        />
      );
    }
    return (
      <TextField
        key={field}
        type={isTimeField ? "time" : isNumber ? "number" : "text"}
        label={labelText}
        value={data[field] || ""}
        required={isRequired}
        onChange={(e) => handleChange(field, e.target.value)}
        size="small"
        sx={{
          ...commonFieldStyles,
          /*  LABEL FIX – consistent positioning for all fields (colors handled by FormThemes) */
          "& .MuiInputLabel-root": {
            transform: "translate(14px, -9px) scale(0.75)",
            transformOrigin: "top left",
            backgroundColor: "#f9f9f9",
            padding: "0 2px", // Reduced vertical padding to decrease background height
            lineHeight: "1.2", // Reduced line height for tighter spacing
            whiteSpace: "nowrap",
          },
          /*  NOTCH FIX */
          "& .MuiOutlinedInput-notchedOutline legend": {
            maxWidth: calculateLegendWidth(labelText),
            width: "auto",
          },
        }}
        InputProps={{
          readOnly: isNumber && ["total_days", "total_hours"].includes(field),
          ...(isTimeField ? { inputProps: { step: 300 } } : {}),
        }}
        InputLabelProps={{ shrink: true }}
        error={!!errors[field]}
        helperText={errors[field]}
      />
    );
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MainLayout>
        <Typography variant="h4" gutterBottom fontSize="25px" fontWeight="600">
          Leave Requests
        </Typography>

        <Box
          display="flex"
          justifyContent="flex-start"
          alignItems="center"
          mt={0.5}
          mb={2}
          gap={2}
        >
          <IconButton onClick={(e) => setColumnAnchorEl(e.currentTarget)}>
            <SettingsIcon fontSize="small" />
          </IconButton>
          <Popover
            open={Boolean(columnAnchorEl)}
            anchorEl={columnAnchorEl}
            onClose={() => setColumnAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            PaperProps={{
              sx: {
                mt: 1,
                p: 1,
                width: 200,
                maxHeight: 300,
                overflowY: "auto",
                borderRadius: 2,
              },
            }}
          >
            <Box p={1} display="flex" flexDirection="column" gap={1}>
              {leaveFields.map((field) => (
                <Box
                  key={field}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{
                    color: "black",
                    border: "1px solid #ccc",
                    borderRadius: 1.5,
                    px: 2,
                    py: 1,
                    backgroundColor: "#fff",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "0.8rem",
                      color: "#333",
                      fontWeight: "bold",
                    }}
                  >
                    {fieldLabels[field]}
                  </Typography>
                  <Switch
                    checked={columnVisibility[field]}
                    onChange={() =>
                      setColumnVisibility((prev) => ({
                        ...prev,
                        [field]: !prev[field],
                      }))
                    }
                    size="small"
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#2DB0E4",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#2DB0E4",
                        },
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Popover>

          <Button
            variant="contained"
            color="primary"
            sx={{
              fontWeight: "bold",
              borderRadius: "8px",
              px: 2.5,
              height: 36,
              backgroundColor: "#2DB0E4",
            }}
            startIcon={<Add />}
            onClick={() => {
              setNewRequest({
                duration_type: "Full/Multiple Days",
                bo_id: boId,
                employee_id: empId || "",
                leave_type: "",
                leave_description: "",
                approval_level_required: approvalLevel || null,
                start_date: null,
                end_date: null,
                total_days: null,
                start_time: null,
                end_time: null,
                total_hours: null,
                is_half_day: false,
                status: "Pending",
                emergency_contact: null,
                is_draft: false,
                alternative_resource: null,
              });
              setOpen(true);
            }}
          >
            Add
          </Button>
          <TextField
            size="small"
            sx={{
              width: 250,
              "& input": { fontSize: 14 },
              "& input::placeholder": { fontSize: 12 },
            }}
            placeholder="Search..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              sx: {
                height: 36,
                paddingRight: 0,
              },
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />

          <TextField
            select
            size="small"
            label="Status"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            sx={{
              width: 200,
              // Make height match the 36px of the search field
              "& .MuiInputBase-root": {
                height: 36,
              },

              // Fix vertical alignment of text
              "& .MuiSelect-select": {
                display: "flex",
                alignItems: "center",
                fontSize: 12,
                padding: "0 14px",
              },

              "& .MuiInputLabel-root": { fontSize: "14px" },
            }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      fontSize: "14px",
                      minHeight: "32px",
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="All">All</MenuItem>
            {statusOptions.map((opt) => (
              <MenuItem key={opt.code} value={opt.code}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <Box
          sx={{ width: "100%", overflowX: "auto", px: 0, py: 2, mt: "-10px" }}
        >
          {alertMsg && (
            <Box mb={2}>
              <Alert
                onClose={() => setAlertMsg("")}
                variant="standard"
                sx={{
                  color: alertSeverity === "success" ? "#2E9F50" : "#FF0C0C",
                  fontWeight: 500,
                  backgroundColor: "#fff",
                }}
              >
                {alertMsg}
              </Alert>
            </Box>
          )}
          <ThemeProvider theme={Table_theme}>
            <CssBaseline />
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        fontWeight: "bold",
                      }}
                    >
                      Actions
                    </TableCell>
                    {leaveFields
                      .filter((f) => columnVisibility[f])
                      .map((field) => (
                        <TableCell
                          key={field}
                          sx={{
                            whiteSpace: "nowrap",
                            textAlign: "center",
                            verticalAlign: "middle",
                          }}
                        >
                          <Box
                            display="inline-flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ gap: 0.5 }}
                          >
                            <strong>{fieldLabels[field]}</strong>
                            <IconButton
                              size="small"
                              onClick={(e) => handleFilterIconClick(field, e)}
                            >
                              <FilterList fontSize="small" />
                            </IconButton>
                            <Popover
                              open={Boolean(anchorEls[field])}
                              anchorEl={anchorEls[field]}
                              onClose={() => handleFilterClose(field)}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                            >
                              <Box
                                p={2}
                                display="flex"
                                flexDirection="column"
                                gap={1}
                                width={200}
                              >
                                <TextField
                                  size="small"
                                  fullWidth
                                  placeholder={`Filter ${fieldLabels[field]}`}
                                  value={filters[field] || ""}
                                  onChange={(e) =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      [field]: e.target.value,
                                    }))
                                  }
                                />
                                <Box
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => handleFilterClose(field)}
                                    sx={{ minWidth: 70 }}
                                  >
                                    Apply
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => {
                                      setFilters((prev) => ({
                                        ...prev,
                                        [field]: "",
                                      }));
                                      handleFilterClose(field);
                                    }}
                                    sx={{ minWidth: 70 }}
                                  >
                                    Clear
                                  </Button>
                                </Box>
                              </Box>
                            </Popover>
                          </Box>
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {requests.map((row, i) => (
                    <TableRow key={i} sx={{ "& td": { fontSize: "12px" } }}>
                      <TableCell>
                        <Box display="flex" gap={0.5} justifyContent="center">
                          <Tooltip title="Edit">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setEditRequest({
                                  ...row,
                                  start_date: row.start_date || null,
                                  end_date: row.end_date || null,
                                  total_days: row.total_days
                                    ? Math.floor(row.total_days)
                                    : null,
                                  start_time: row.start_time
                                    ? row.start_time.slice(0, 5)
                                    : null,
                                  end_time: row.end_time
                                    ? row.end_time.slice(0, 5)
                                    : null,
                                  total_hours: row.total_hours || null,
                                  status: row.status || null,
                                  emergency_contact:
                                    row.emergency_contact || null,
                                  alternative_resource:
                                    row.alternative_resource || null,
                                  is_draft: row.is_draft || false,
                                  is_half_day: row.is_half_day || false,
                                  approval_level_required:
                                    row.approval_level_required || null,
                                });
                                setEditOpen(true);
                              }}
                              sx={{ color: "#2DB0E4" }}
                            >
                              <EditOutlinedIcon sx={{ fontSize: "16px" }} />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              size="small"
                              onClick={() => confirmDelete(row)}
                            >
                              <DeleteIcon
                                fontSize="small"
                                sx={{ color: "red" }}
                              />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Toggle Delete Flag">
                            <IconButton
                              size="small"
                              onClick={() => handleToggleFlag(row.request_id)}
                            >
                              <FlagIcon
                                style={{
                                  color:
                                    row.delete_flag === "N"
                                      ? "#2E9F50"
                                      : "#FF0C0C",
                                  transition: "color 0.2s",
                                  width: 17,
                                  height: 17,
                                  verticalAlign: "middle",
                                }}
                              />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>

                      {leaveFields
                        .filter((f) => columnVisibility[f])
                        .map((field) => (
                          <TableCell
                            key={field}
                            sx={{ fontSize: "0.7rem", whiteSpace: "nowrap" }}
                          >
                            {[
                              "start_date",
                              "end_date",
                              "submitted_at",
                              "last_updated",
                            ].includes(field) && row[field]
                              ? moment(row[field]).format("MM/DD/YYYY")
                              : field === "leave_type"
                              ? row[field]
                              : field === "employee_name"
                              ? row.bo_id && boToEmployeesMap[row.bo_id]
                                ? boToEmployeesMap[row.bo_id].find(
                                    (emp) => emp.employee_id === row.employee_id
                                  )
                                  ? `${
                                      boToEmployeesMap[row.bo_id].find(
                                        (emp) =>
                                          emp.employee_id === row.employee_id
                                      ).first_name
                                    } ${
                                      boToEmployeesMap[row.bo_id].find(
                                        (emp) =>
                                          emp.employee_id === row.employee_id
                                      ).last_name
                                    }`
                                  : row.employee_id
                                : row.employee_id
                              : field === "alternative_resource"
                              ? getAlternativeResourceName(
                                  row.alternative_resource_name
                                )
                              : field === "approver_id"
                              ? row.approvalHistory &&
                                row.approvalHistory.length > 0
                                ? row.approvalHistory.map((a) => (
                                    <span
                                      key={a.approver_id}
                                      title={`ID: ${a.approver_id}`}
                                    >
                                      {a.approver_name}
                                    </span>
                                  ))
                                : " "
                              : field === "total_days"
                              ? formatDays(row[field])
                              : field === "total_hours"
                              ? formatHours(row[field])
                              : row[field]}
                          </TableCell>
                        ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={Math.ceil(totalCount / rowsPerPage)}
                page={page + 1}
                onChange={(_, newPage) => setPage(newPage - 1)}
                color="primary"
                variant="outlined"
                shape="rounded"
                sx={{
                  "& .MuiPaginationItem-root": {
                    borderRadius: "8px",
                    minWidth: "32px",
                    height: "32px",
                    fontSize: "14px",
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#b3dbea !important",
                    color: "black",
                    fontWeight: "bold",
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    display: "none",
                  },
                }}
              />
            </Box>
          </ThemeProvider>
        </Box>

        <ThemeProvider theme={FormThemes}>
          <CssBaseline />
          <Dialog
            open={open}
            onClose={() => {
              setOpen(false);
              setErrors({});
            }}
            fullWidth
            maxWidth="sm"
            sx={{ top: "-20%" }}
          >
            <DialogTitle
              sx={{
                borderRadius: "12px",
                bgcolor: "#f5f5f5",
                p: 1,
                fontSize: "16px",
                fontWeight: 600,
                borderBottom: "1px solid #ddd",
              }}
            >
              Add Leave Request
            </DialogTitle>
            <DialogContent
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "0.5px",
                columnGap: 0,
                paddingTop: 2,
                p: "16px 40px",
                mt: 1,
              }}
            >
              {popupFields.map((field) =>
                renderField(field, newRequest, setNewRequest)
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpen(false);
                  setErrors({});
                }}
              >
                Cancel
              </Button>
              <Button onClick={handleAdd} variant="contained">
                Save
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={editOpen}
            onClose={() => {
              setEditOpen(false);
              setErrors({});
            }}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle
              sx={{
                borderRadius: "12px",
                bgcolor: "#f5f5f5",
                p: 1,
                fontSize: "16px",
                fontWeight: 600,
                borderBottom: "1px solid #ddd",
              }}
            >
              Update Leave Request
            </DialogTitle>
            <DialogContent
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "0.5px",
                columnGap: 0,
                paddingTop: 2,
                p: "16px 40px",
                mt: 1,
              }}
            >
              {popupFields.map((field) =>
                renderField(field, editRequest, setEditRequest)
              )}
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setEditOpen(false);
                  setErrors({});
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                sx={{
                  fontWeight: "bold",
                  borderRadius: "8px",
                  px: 2.5,
                  height: 36,
                  backgroundColor: "#45a049",
                }}
                onClick={handleEdit}
              >
                Update
              </Button>
            </DialogActions>
          </Dialog>
          {getConfirmDeleteDialog({
            open: deleteDialogOpen,
            onClose: () => {
              setDeleteDialogOpen(false);
              setSelectedRequest(null);
            },
            onConfirm: () => {
              if (selectedRequest) {
                handleDelete(selectedRequest.request_id);
              }
              setDeleteDialogOpen(false);
              setSelectedRequest(null);
            },
            title: "Confirm Deletion",
            contentText: selectedRequest
              ? `Are you sure you want to delete the request for ${getEmployeeName(
                  selectedRequest
                )}?`
              : "Are you sure you want to delete this request?",
          })}
        </ThemeProvider>
      </MainLayout>
    </LocalizationProvider>
  );
};

export default LeaveRequest;
